module.exports = [
    {
        prompt: 'What was Pedrito\'s car license plate when he was a party boy?',
        choices: ['Rumbero','Salsero','Parcero','Dinero','Cocinero'],
        answer: 'Rumbero'
    },
    {
        prompt: 'How many sisters does abuelita Yolanda have?',
        choices: ['2','3','1','5','8'],
        answer: '2'
    },
    {
        prompt: 'How many brothers does abuelita Yolanda have?',
        choices: ['2','3','1','5','8'],
        answer: '5'
    },
    {
        prompt: 'What was Tío German\'s car license plate on his red Mercedes?',
        choices: ['Ego One','Santa Claus','Vodka Vodka','Ohio','Bolivar'],
        answer: 'Ego One'
    },
    {
        prompt: 'Where did Abuelita Yolanda meet Abuelito Pedro?',
        choices: ['Bucaramanga','Cali','Bogota','Michigan','Ohio'],
        answer: 'Cali'
    },
    {
        prompt: 'En que fecha se caso abuelita Yolanda y Abuelito Pedro?',
        choices: ['Julio 8','Junio 12','Febrero 14','Diciembre 4','Agosto 3'],
        answer: 'Junio 12'
    },
    {
        prompt: 'What countries has abuelita Yolanda not been in?',
        choices: ['Italia','España','Francia','Canada','Inglaterra'],
        answer: 'Inglaterra'
    },
    {
        prompt: 'Quién es el perro mas cute?',
        choices: ['Teddy','James'],
        answer: 'James'
    },
    {
        prompt: 'Who has NOT been on a TV show?',
        choices: ['Abuelita','Carolina', 'Danny'],
        answer: 'Danny'
    },
    {
        prompt: 'What does tata like the most of the options below?',
        choices: ['Lipstick','Coronavirus', 'Taking care of pets', 'Cleaning'],
        answer: 'Lipstick'
    },
    {
        prompt: 'Where did abuelo Pedro work when he left Colombia?',
        choices: ['Korea','South Africa', 'Japan', 'Spain'],
        answer: 'Japan'
    },
    {
        prompt: 'In which city did tio Danny NOT live in?',
        choices: ['Sevilla','Madrid', 'Providence', 'Miami', 'Nashville'],
        answer: 'Nashville'
    },
    {
        prompt: 'What did tio German do for a living?',
        choices: ['Make yummy food','Work as a Psychiatrist', 'Dancer', 'Baker', 'Banker'],
        answer: 'Work as a Psychiatrist'
    },
    {
        prompt: 'What country did your tia Carolina not visit?',
        choices: ['China','Japan', 'Turkey', 'France', 'Russia', 'Germany'],
        answer: 'Russia'
    },
    {
        prompt: 'Which is NOT one of tia Carolina\'s companies?',
        choices: ['Osiriana','Canela Pura Americas','Sun Events', 'Targetbridge', 'Prada Designers', 'Creativepreneur', 'Party Pal'],
        answer: 'Party Pal'
    },
    {
        prompt: 'In what year was tio German born',
        choices: ['1931','1924','1918','1950','1305'],
        answer: '1931'
    },
    {
        prompt: 'Which artist did your tío Danny shake hands with at work?',
        choices: ['Don Omar','Ozuna','Prince Royce','Ivy Queen','Cauty'],
        answer: 'Ozuna'
    },
    {
        prompt: 'Where has tia Carolina NOT performed Flamenco in?',
        choices: ['The Arsht Center','Telemundo w/ David Bisbal','Bahamas','Viscaya Museum','Bimini'],
        answer: 'Bimini'
    },
    {
        prompt: 'Pedrito works at?',
        choices: ['Salesforce','FBI','America\'s Got Talent','GNC','Acumen'],
        answer: 'Acumen'
    },
    {
        prompt: 'Your great grandmother Alejandrina could use a revolver and shoot a turkey\'s head from 20 feet?',
        choices: ['True','False','Wut?'],
        answer: 'True'
    }
]
